// extracted by mini-css-extract-plugin
module.exports = {"statsRow":"PlayerStats_statsRow__2jdCb","placeholder":"PlayerStats_placeholder__2DYpi"};